module.exports = __webpack_public_path__ + "assets/img/download-screenshot.705fa21a.png";